import React, {Component} from 'react';
import MaterialIcon from '../MaterialIcon';
/*
 * Props:
 *   toastType: error, warning, success, info(default)
 *   title: Toast title
 *   message: Toast message
 */

export default class ToastMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toastIcon: 'info',
            hidden: false,
            title: this.props.toast.title ? this.props.toast.title : ""
        };
    }

    parseMessage() {
        const text = this.props.toast?.message?.split('.');
        if (text && text.length > 2) {
            text.shift();
        }
        return (
            <div>
                {text && text.map((sentence, index) => (
                    <React.Fragment key={index}>
                        {sentence}
                        <br/>
                    </React.Fragment>
                ))}
            </div>
        )
    }

    componentDidMount() {
        const text = this.props.toast?.message?.split('.');
        if (this.state.title === "" && text && text.length >= 2) {
            this.setState({ title: text.shift()
            });
        }
        switch (this.props.toast.toastType) {
            case 'success':
                this.setState({
                    toastIcon: 'done'
                });
                break;
            case 'error':
                this.setState({
                    toastIcon: 'cancel'
                });
                break;
            case 'warning':
                this.setState({
                    toastIcon: 'warning'
                });
                break;
            default:
                this.setState({
                    toastIcon: 'info'
                });
                break;
        }
    }

    closeToast() {
        this.setState({
            hidden: true
        });
    }

    render() {
        return (
            !this.state.hidden && this.props.toast && (
                <div className="toast-message-container" onClick={this.closeToast.bind(this)}>
                    <div className={'toast-message toast-message--' + this.props.toast.toastType}>
                        <span className="toast-message__close">
                            <MaterialIcon icon="close"/>
                        </span>
                        <span className="toast-message__icon">
                            <MaterialIcon icon={this.state.toastIcon}/>
                        </span>
                        <div className="toast-message__info">
                            <h4>{this.state.title}</h4>
                            {this.parseMessage()}
                        </div>
                    </div>
                </div>
            )
        );
    }
}
